export default __webpack_public_path__ + "static/media/green-edit-icon.b10e1957.svg";